export const header = [
  {
    name: 'Home',
    path: '/',
    children: []
  },
  {
    name: 'Luminous valances',
    path: '/luminous-valances',
    children: []
  },
  /*{
    name: 'Nos Services',
    path: '',
    children: [
      {
        name: 'Stores Exterieurs',
        path: '/store'
      },
      {
        name: 'Pergolas',
        path: '/pergola'
      },
      {
        name: 'Enseignes',
        path: '/enseigne'
      },
      {
        name: 'Claustras',
        path: '/claustras'
      },
      {
        name: 'Radiants',
        path: '/radiants'
      }
    ]
  },*/
  {
    name: 'Gallery',
    path: '/our-achievements',
    children: []
  },
  {
    name: 'References',
    path: '/our-references',
    children: []
  },
  {
    name: 'Contact',
    path: '/contact',
    children: []
  }
]
